import PriceSummary from './PriceSummary';

export default PriceSummary;
export type { PriceSummaryProps } from './GenericPriceSummary';
export type { PriceUpTo } from './PriceSummary.controller';
export { PriceSummaryV2 } from '@apps/card/components/Receipt/PriceSummaryV2';
export type { PriceSummaryV2Props } from '@apps/card/components/Receipt/PriceSummaryV2';
